// SSL / TLS overview hero — card shells match Configuration HeroCard (certsLayout).

import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import {
  WAFOverviewIconChip,
  WAFOverviewStatNumber,
  WAF_OVERVIEW_ICON_SX,
  wafOverviewLabelSx,
  wafOverviewLabelContentMt,
  wafOverviewSubSx,
  wafOverviewStatNumberSx,
} from "../../services/web_application/components/WAFOverviewMetricCard";
import { certsHeroMetricCardSx, certsHeroMetricCardHighlightSx } from "../certsLayout";

export {
  WAFOverviewIconChip as SSLOverviewIconChip,
  WAFOverviewStatNumber as SSLOverviewStatNumber,
  WAF_OVERVIEW_ICON_SX as SSL_OVERVIEW_ICON_SX,
  wafOverviewLabelSx as sslOverviewLabelSx,
  wafOverviewSubSx as sslOverviewSubSx,
  wafOverviewStatNumberSx as sslOverviewValueSx,
};

export const sslMetricCardSx = certsHeroMetricCardSx;
export const sslMetricCardHighlightSx = certsHeroMetricCardHighlightSx;

export { wafOverviewGridSx as sslOverviewGridSx } from "../../services/web_application/components/WAFDashboardOverviewStrip";

/** Single overview metric panel — same bg/border as Configuration hero cards. */
export default function SSLOverviewMetricCard({ icon, label, children, highlight = false, sx }) {
  return (
    <Box sx={{
      ...certsHeroMetricCardSx,
      ...(highlight ? certsHeroMetricCardHighlightSx : {}),
      ...sx,
    }}>
      <Stack sx={{ minWidth: 0 }}>
        {icon ? (
          <Stack direction="row" alignItems="center" spacing={1}>
            {icon}
            <Typography component="span" data-overview-label sx={wafOverviewLabelSx}>{label}</Typography>
          </Stack>
        ) : (
          <Typography component="span" data-overview-label sx={wafOverviewLabelSx}>{label}</Typography>
        )}
        <Box sx={{ minWidth: 0, mt: wafOverviewLabelContentMt }}>{children}</Box>
      </Stack>
    </Box>
  );
}
